var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { width: "75%" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on }) {
              return [_vm._t("clickable", null, { on: on })]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline grey", attrs: { "primary-title": "" } },
            [_vm._v(" About Heimdall " + _vm._s(_vm.instanceMode) + " ")]
          ),
          _c("v-card-text", [
            _c("p", [
              _c("br"),
              _c("span", { staticClass: "title" }, [
                _vm._v(" " + _vm._s(_vm.version) + " "),
              ]),
              _c("br"),
              _c("br"),
              _c("span", { staticClass: "subtitle-2" }, [
                _c("strong", [_vm._v("Changelog:")]),
                _c(
                  "a",
                  { attrs: { href: "" + _vm.repository + _vm.changelog + "" } },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.repository) + _vm._s(_vm.changelog) + " "
                    ),
                  ]
                ),
              ]),
              _c("br"),
              _c("span", { staticClass: "subtitle-2" }, [
                _c("strong", [_vm._v("Github:")]),
                _c("a", { attrs: { href: "" + _vm.repository + "" } }, [
                  _vm._v(" " + _vm._s(_vm.repository) + " "),
                ]),
              ]),
              _c("br"),
              _c("span", { staticClass: "subtitle-2" }, [
                _c("br"),
                _vm._v(
                  " If you would like to report an Issue or Feature Request, "
                ),
                _c(
                  "a",
                  { attrs: { href: "" + _vm.repository + _vm.issues + "" } },
                  [_vm._v(" let us know on github. ")]
                ),
              ]),
            ]),
          ]),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v("Close Window")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }